import { FEEDBACK } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: FEEDBACK,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  params: {},
  extraParams: {},
  allowStatus: {},
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '请输入问题与建议/工具/反馈人员/反馈分类/节省时间',
    searchFieldNameArr: ['feedback', 'createUser', 'toolName', 'saveTimeRate'],
    items: []
  },
  class: 'sk-custom-table-right-page',
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: '工具',
          prop: 'toolName',
          width: 260
        }
      },
      {
        props: {
          label: '节省多少时间',
          prop: 'saveTimeRate'
        }
      },
      {
        props: {
          label: '推荐指数',
          prop: 'recommendRating'
        },
        dataType: 'custom',
        custom: function(row, h, value, e) {
          var recommendRatingDesc = ''
          if (value >= 0 && value <= 6) {
            recommendRatingDesc = value + '（不推荐）'
          } else if (value >= 7 && value <= 8) {
            recommendRatingDesc = value + '（可能推荐）'
          } else if (value >= 9 && value <= 10) {
            recommendRatingDesc = value + '（推荐）'
          }
          return <span>{recommendRatingDesc}</span>
        }
      },
      {
        props: {
          label: '问题与建议',
          prop: 'feedback'
        }
      },
      {
        props: {
          label: '回复内容',
          prop: 'replyContent'
        }
      },
      {
        props: {
          label: '反馈人员',
          prop: 'createUser',
          width: 100
        }
      },
      {
        props: {
          label: '反馈时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        props: {
          showBtnNum: '2',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-upload',
        label: '回复',
        command: 'FeedbackReply',
        name: 'FeedbackReply'
      }
    ]
  }
}
